<template>
  <SectionLayout>
    <template #header>
      <SectionLayoutHeaderDark />
    </template>
    <TerminalContent :encrypted="encrypted" />
    <template #footer>
      <SectionLayoutFooterDark />
    </template>
  </SectionLayout>
</template>

<script>
import SectionLayout from '@/components/Layout/SectionLayout'
import SectionLayoutFooterDark from '@/components/Layout/SectionLayoutFooterDark'
import SectionLayoutHeaderDark from '@/components/Layout/SectionLayoutHeaderDark'
import TerminalContent from './Terminal/TerminalContent'

export default {
  name: 'Terminal',

  components: { SectionLayout, SectionLayoutFooterDark, SectionLayoutHeaderDark, TerminalContent },

  props: {
    encrypted: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
